import {writable} from 'svelte/store';
import {PAYMENT_TYPE} from "../js/constants.js";

let departmentObject = {
    id: null,
    name: null,
    email: null,
    payment_method: PAYMENT_TYPE.CARD,
    token: null,
};

const {get, set, update, subscribe} = writable(departmentObject);

const department$ = {
    set,
    update,
    subscribe,

    setData: data => {
        department$.update(obj => {
            obj.id = data.id;
            obj.account_id = data.account_id;
            obj.link_code = data.link_code;
            obj.name = data.name;
            obj.hotels = data.hotels;
            obj.payment_method = ~~data.payment_method;

            return obj;
        });
    },

}

export default department$;